import axios from 'axios';
import { Api } from 'constants/urls';
import { FIEnvArtifact, GetArtifactListRequestBody, SetArtifactRequestBody } from 'interfaces';

const setConfigToIntegrator = async (branch: string, environment: string, app: string) => {
  await axios.post(Api.SET_CONFIG_TO_INTEGRATOR, { branch, env: environment, app });
};

const getAppsList = async (env: number) => {
  const { data } = await axios.get(Api.GET_APPS_LIST, {
    params: {
      env,
    },
  });
  return data;
};

const getArtifacts = async (body: GetArtifactListRequestBody): Promise<FIEnvArtifact> => {
  const response = await axios.get(Api.GET_FI_ARTIFACTS, {
    params: body,
  });

  return response.data;
};

const getMacros = async (firstEnvironment: number, secondEnvironment: number, firstApp: string, secondApp: string) => {
  const response = await axios.get(Api.GET_FI_MACROS, {
    params: {
      firstEnvironment,
      secondEnvironment,
      firstApp,
      secondApp,
    },
  });

  return response.data;
};

const getPlugins = async (firstEnvironment: number, secondEnvironment: number, firstApp: string, secondApp: string) => {
  const response = await axios.get(Api.GET_FI_PLUGINS, {
    params: {
      firstEnvironment,
      secondEnvironment,
      firstApp,
      secondApp,
    },
  });

  return response.data;
};

const setArtifactToDiffEnv = async ({
  name, content, envToSet, type,
}: SetArtifactRequestBody) => {
  const result = await axios.post(Api.SET_FI_ARTIFACT, {
    name,
    content,
    type,
    envToSet,
  });
  return result.data;
};

const updateArtifact = async ({
  name, content, envToSet, type, app,
}: SetArtifactRequestBody) => {
  const result = await axios.post(Api.UPDATE_FI_ARTIFACT, {
    name,
    content,
    type,
    envToSet,
    app,
  });
  return result.data;
};

const getEnvList = async () => {
  const result = await axios.get(Api.GET_ENV_LIST);
  return result.data;
};

export const integratorService = {
  setConfigToIntegrator,
  getMacros,
  getPlugins,
  getAppsList,
  setArtifactToDiffEnv,
  updateArtifact,
  getEnvList,
  getArtifacts,
};
